// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBoxPlotOutlinedSvg from "@fishx/icons-svg/es/asn/PBoxPlotOutlined";
import FishxIcon from '../components/FishxIcon';

var PBoxPlotOutlined = function PBoxPlotOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBoxPlotOutlinedSvg
  }));
};

PBoxPlotOutlined.displayName = 'PBoxPlotOutlined';
export default React.forwardRef(PBoxPlotOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBoxPlotOutlined.js
// module id = 3255
// module chunks = 0